import {combineReducers} from '@reduxjs/toolkit';

import {excelPluginUsageReportsStateSlice} from './generated-reports/slices/excel-plugin-usage-reports-state.slice';
import {excelPluginUsageReportsSlice} from './generated-reports/slices/excel-plugin-usage-reports.slice';

export const excelPluginUsageReportReducer = combineReducers({
    reports: excelPluginUsageReportsSlice.reducer,
    state: excelPluginUsageReportsStateSlice.reducer,
});
